"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeoutPromise = exports.setTimeoutFramesAsync = exports.setTimeoutAsync = void 0;
function setTimeoutAsync(ms, useCancel = null) {
    let canceled = false;
    let _reject;
    let token;
    const res = new Promise((resolve, reject) => {
        _reject = reject;
        token = setTimeout(() => {
            _reject = null;
            if (!canceled) {
                resolve();
            }
        }, ms);
    });
    if (useCancel) {
        const cancelCb = () => {
            clearTimeout(token);
            canceled = true;
            if (_reject) {
                _reject();
            }
        };
        useCancel(cancelCb);
    }
    return res;
}
exports.setTimeoutAsync = setTimeoutAsync;
/* global requestAnimationFrame */
function setTimeoutFramesAsync(frames) {
    if (typeof requestAnimationFrame === 'undefined') {
        throw new Error('setTimeoutFramesAsync is not supported because "requestAnimationFrame" is not defined.');
    }
    return new Promise(resolve => {
        let left = frames || 0;
        const cb = () => {
            if (--left <= 0) {
                resolve();
            }
            else {
                requestAnimationFrame(cb);
            }
        };
        cb();
    });
}
exports.setTimeoutFramesAsync = setTimeoutFramesAsync;
function timeoutPromise(p, timeoutMs, waitForMinElapsed) {
    const started = Date.now();
    return new Promise((resolve, reject) => {
        let finished = false;
        const finish = (res, timedOut) => {
            if (finished) {
                return;
            }
            finished = true;
            const getElapsed = () => (Date.now() - started);
            const doFinish = () => resolve({ resolved: res, timedOut: timedOut, elapsed: getElapsed() });
            const left = waitForMinElapsed != null ? (waitForMinElapsed - getElapsed()) : -1;
            if (left >= 0) {
                setTimeout(doFinish, left);
            }
            else {
                doFinish();
            }
        };
        const timeoutRef = setTimeout(() => {
            finish(undefined, true);
        }, timeoutMs);
        p.then(res => {
            clearTimeout(timeoutRef);
            finish(res, false);
        }).catch(reject);
    });
}
exports.timeoutPromise = timeoutPromise;
//# sourceMappingURL=timeout.js.map